<script lang="ts">
  import { ListLayoutRelative } from '@shared/ui/list';

  import { ArtAssetCard, artAssetCardModel, type SimilarArtAssets } from '@entities/art-asset';

  export let similarProducts: SimilarArtAssets;
</script>

{#if similarProducts.length}
  <div
    class="no-scrollbar border-default-300 dark:border-dark-400 mb-10 flex justify-between
        overflow-x-scroll border-b pb-3 font-medium md:justify-start md:gap-9"
  >
    Similar Artworks
  </div>

  <ListLayoutRelative products="{similarProducts}" let:product let:breakpoints>
    {#key product.id}
      <ArtAssetCard
        {...artAssetCardModel.mapApiToData(product)}
        {breakpoints}
        isImageBlurred="{!!product.content_flags.length}"
      />
    {/key}
  </ListLayoutRelative>
{/if}
